/**
 * @file c
 */
'use strict';

/**
 * @classname LongProcess
 * @classdesc 長時間送信
 */
export default class LongProcess {
	/**
	 * @constructor
	 * @param {jQuery} $e - button[type=button]
	 */
	constructor($e) {
		console.log('LongProcess.constructor');
		this._$e = $e;
		this._$e.on('click', () => this.onClick());
	};


	/**
	 * クリックのコールバック
	 *
	 * @memberof LongProcess
	 * @return {undefined}
	 */
	onClick() {
		console.log('LongProcess.onClick');
		this._$e.append('<i class="fa fa-spinner fa-pulse fa-fw ml8"></i>')
	};
}
